"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL_ADAPTER_METHODS = void 0;
exports.assertChannelAdapter = assertChannelAdapter;
// The uniform contract every channel adapter must satisfy — see ./types.js's
// ChannelAdapter typedef for the full method list. Today only socketIoAdapter
// (adapters/socketIoAdapter.js) implements it; a future WooChat adapter
// implements the same shape so nothing above this layer (reducer, hooks,
// presentational components) needs to change when it's added.
const REQUIRED_METHODS = exports.CHANNEL_ADAPTER_METHODS = ["connect", "disconnect", "joinRoom", "leaveRoom", "sendMessage", "emitTyping", "emitStopTyping", "onMessage", "onMessageReplaced", "onMessageDeleted", "emitReactToMessage", "onMessageReacted", "onRequireResponse", "onRequireResponseClosed", "onTyping", "onStopTyping", "onPresence", "onSeen"];

// Dev-time guard for adapter authors — throws early with a clear message
// instead of a confusing "adapter.onX is not a function" deep inside a hook.
function assertChannelAdapter(adapter) {
  const missing = REQUIRED_METHODS.filter(method => typeof (adapter === null || adapter === void 0 ? void 0 : adapter[method]) !== "function");
  if (missing.length > 0) {
    throw new Error("Invalid channel adapter: missing method(s) ".concat(missing.join(", ")));
  }
  return adapter;
}